import React, { useEffect, useState } from "react";

const SubmissionReviewWindow = ({ submissionDetails, isVisible, onClose }) => {
  const [submission, setSubmission] = useState(submissionDetails);
  const [files, setFiles] = useState(null);
  const [feedback, setFeedback] = useState(null);
  const [fileType, setFileType] = useState(null);
  const [showTeacherModal, setShowTeacherModal] = useState(false);
  const [searchTerm, setSearchTerm] = useState("");
  const [teachers] = useState([
    "Dr. Smith",
    "Dr. Johnson",
    "Prof. Anderson",
    "Dr. Williams",
  ]); /* some fake tchrs */
  const [selectedTeacher, setSelectedTeacher] = useState(null);

  const filteredTeachers = teachers.filter((t) =>
    t.toLowerCase().includes(searchTerm.toLowerCase())
  );

  React.useEffect(() => {
    const getSubmissions = async () => {
      if (!submissionDetails) return;
      const response = await fetch(
        `${process.env.REACT_APP_API_BASE}/submissions/${submissionDetails?.id}/details`,
        {
          method: "GET",
          headers: {
            Authorization: `Bearer: ${localStorage.token}`,
            // don't
            "ngrok-skip-browser-warning": "true",
          },
        }
      );

      if (!response.ok) {
        localStorage.removeItem("token");
        window.location.href = "/";
      }

      let parseRes = await response.json();

      setSubmission(parseRes);
    };
    getSubmissions();
  }, [isVisible]);

  React.useEffect(() => {
    const getFiles = async () => {
      if (!submissionDetails) return;
      const response = await fetch(
        `${process.env.REACT_APP_API_BASE}/submissions/${submissionDetails?.id}/files/list/details`,
        {
          method: "GET",
          headers: {
            Authorization: `Bearer: ${localStorage.token}`,
            "ngrok-skip-browser-warning": "true",
          },
        }
      );

      if (!response.ok) {
        localStorage.removeItem("token");
        window.location.href = "/";
      }

      let parseRes = await response.json();

      setFiles(parseRes);
    };
    getFiles();
  }, [isVisible]);

  const downloadFile = async (fileId) => {
    try {
      const response = await fetch(
        `${process.env.REACT_APP_API_BASE}/submissions/${submissionDetails?.id}/files/download/${fileId}`,
        {
          method: "GET",
          headers: {
            Authorization: `Bearer: ${localStorage.token}`,
            "ngrok-skip-browser-warning": "true",
          },
          mode: "cors",
        }
      );

      if (!response.ok) {
        alert("Could not download file");
        return;
      }

      const blob = await response.blob();
      const url = URL.createObjectURL(blob);
      let filename = "download.pdf";
      const disposition = response.headers.get("Content-Disposition");
      if (disposition && disposition.includes("filename=")) {
        const match = disposition.match(/filename="?([^"]+)"?/);
        if (match && match[1]) filename = match[1];
      }

      const link = document.createElement("a");
      link.href = url;
      link.download = filename;
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
      URL.revokeObjectURL(url);
    } catch (error) {
      console.error(error);
      alert("Failed to download file");
    }
  };

  const downloadPresetExaminer = async () => {
    try {
      const response = await fetch(
        `${process.env.REACT_APP_API_BASE}/submissions/${submissionDetails?.id}/files/download/preset/examiner`,
        {
          method: "GET",
          headers: {
            Authorization: `Bearer: ${localStorage.token}`,
            "ngrok-skip-browser-warning": "true",
          },
          mode: "cors",
        }
      );

      if (!response.ok) {
        alert("Could not download file");
        return;
      }

      const blob = await response.blob();
      const url = URL.createObjectURL(blob);
      let filename = "download.pdf";
      const disposition = response.headers.get("Content-Disposition");
      if (disposition && disposition.includes("filename=")) {
        const match = disposition.match(/filename="?([^"]+)"?/);
        if (match && match[1]) filename = match[1];
      }

      const link = document.createElement("a");
      link.href = url;
      link.download = filename;
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
      URL.revokeObjectURL(url);
    } catch (error) {}
  };

  const downloadPresetCombined = async () => {
    try {
      const response = await fetch(
        `${process.env.REACT_APP_API_BASE}/submissions/${submissionDetails?.id}/files/download/preset/combined`,
        {
          method: "GET",
          headers: {
            Authorization: `Bearer: ${localStorage.token}`,
            "ngrok-skip-browser-warning": "true",
          },
          mode: "cors",
        }
      );

      if (!response.ok) {
        alert("Could not download file");
        return;
      }

      const blob = await response.blob();
      const url = URL.createObjectURL(blob);
      let filename = "download.pdf";
      const disposition = response.headers.get("Content-Disposition");
      if (disposition && disposition.includes("filename=")) {
        const match = disposition.match(/filename="?([^"]+)"?/);
        if (match && match[1]) filename = match[1];
      }

      const link = document.createElement("a");
      link.href = url;
      link.download = filename;
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
      URL.revokeObjectURL(url);
    } catch (error) {}
  };

  async function uploadFeedback() {
    const formData = new FormData();
    formData.append("file", feedback);
    formData.append("type", fileType);
    try {
      await fetch(
        `${process.env.REACT_APP_API_BASE}/submissions/${submission.id}/files/upload`,
        {
          method: "POST",
          body: formData,
          headers: {
            Authorization: `Bearer: ${localStorage.token}`,
            "ngrok-skip-browser-warning": "true",
          },
        }
      );
    } catch (e) {
      console.error(e);
    }
  }

  async function reviewSubmission() {
    try {
      await fetch(
        `${process.env.REACT_APP_API_BASE}/submissions/${submission.id}/review`,
        {
          method: "GET",
          headers: {
            Authorization: `Bearer: ${localStorage.token}`,
            "ngrok-skip-browser-warning": "true",
          },
        }
      );
      window.location.reload();
    } catch (e) {
      console.error(e);
    }
  }

  return (
    <>
      <div
        className={`fixed inset-0 z-50 flex items-center justify-center bg-gray-800 bg-opacity-50 transition-opacity ${
          isVisible ? "opacity-100 visible" : "opacity-0 invisible"
        }`}
        onClick={onClose}
      >
        <div
          className="bg-white w-full max-w-4xl rounded-lg shadow-lg p-6 transform transition-transform"
          onClick={(e) => e.stopPropagation()}
          style={{
            transform: isVisible ? "translateY(0)" : "translateY(-50%)",
            transition: "transform 0.3s ease-out",
          }}
        >
          <div className="flex justify-between items-center mb-4">
            <h2 className="text-xl font-medium text-gray-900">
              Submission Details
            </h2>
            <button
              onClick={onClose}
              className="text-gray-500 hover:text-gray-700 focus:outline-none"
            >
              <i className="fas fa-times"></i>
            </button>
          </div>

          <div className="space-y-4">
            <div className="bg-white p-6 rounded-lg border">
              <div className="flex justify-between items-center mb-6">
                <div>
                  <h3 className="text-xl font-medium text-gray-900">
                    {submission?.student_name} - {submission?.course_name}
                  </h3>
                  <p className="text-sm text-gray-500">
                    {submission?.company_name}
                  </p>
                  <p className="text-sm text-gray-500">
                    Submitted: {submission?.date}
                  </p>
                </div>
                <span className="px-3 py-1 text-sm font-medium rounded-full bg-yellow-100 text-yellow-800">
                  {submission?.status}
                </span>
              </div>

              <div className="grid grid-cols-2 gap-8">
                {/* Student Submission */}
                <div className="space-y-4">
                  <h4 className="text-lg font-medium text-gray-900">
                    Student Submission
                  </h4>
                  <div className="border rounded-lg p-4 space-y-3">
                    {files
                      ?.filter(
                        (file) =>
                          file.type !== "First Draft Feedback" &&
                          file.type !== "Examiner's Feedback" &&
                          file.type !== "Graduation Assessment Form"
                      )
                      .map((file) => (
                        <div
                          key={file.id}
                          className="flex items-center justify-between"
                        >
                          <div className="flex items-center space-x-2">
                            <i className="fas fa-file-pdf text-red-500 text-xl"></i>
                            <span className="text-sm font-medium">
                              {file?.type} - {file?.name}
                            </span>
                          </div>
                          <button
                            onClick={() => downloadFile(file?.id)}
                            className="text-custom hover:text-custom/80"
                          >
                            <i className="fas fa-download"></i>
                          </button>
                        </div>
                      ))}
                  </div>

                  {/* Static Draft Documents */}
                  <div className="mt-6 space-y-4">
                    <h4 className="text-lg font-medium text-gray-900">
                      Suplementary Documents
                    </h4>
                    <div className="border rounded-lg p-4 space-y-3">
                      {files
                        ?.filter(
                          (file) =>
                            file.type === "First Draft Feedback" ||
                            file.type === "Examiner's Feedback" ||
                            file.type === "Graduation Assessment Form"
                        )
                        .map((file) => (
                          <div
                            key={file.id}
                            className="flex items-center justify-between"
                          >
                            <div className="flex items-center space-x-2">
                              <i className="fas fa-file-pdf text-red-500 text-xl"></i>
                              <span className="text-sm font-medium">
                                {file?.type} - {file?.name}
                              </span>
                            </div>
                            <button
                              onClick={() => downloadFile(file?.id)}
                              className="text-custom hover:text-custom/80"
                            >
                              <i className="fas fa-download"></i>
                            </button>
                          </div>
                        ))}
                      {files?.filter(
                        (file) =>
                          file.type === "First Draft Feedback" ||
                          file.type === "Examiner's Feedback"
                      ).length === 0 && (
                        <span className="text-sm font-medium">
                          Nothing here yet.
                        </span>
                      )}
                    </div>
                  </div>
                </div>

                {submission?.status !== "Reviewed" ? (
                  <div className="space-y-4 border-b pb-6">
                    <div className="flex justify-between items-center">
                      <h4 className="text-lg font-medium text-gray-900">
                        Teacher Review
                      </h4>
                      <button
                        onClick={
                          files?.filter(
                            (file) => file.type === "Examiner's Feedback"
                          ).length < 2
                            ? downloadPresetExaminer
                            : downloadPresetCombined
                        }
                        className="px-4 py-2 text-sm font-medium text-black bg-green-400 rounded-md shadow-sm hover:bg-green-300"
                      >
                        Download preset{" "}
                        {files?.filter(
                          (file) => file.type === "Examiner's Feedback"
                        ).length < 2
                          ? "(Individual)"
                          : "(Graduation)"}
                      </button>
                    </div>
                    <div className="border rounded-lg p-4 space-y-4">
                      <div className="space-y-2">
                        <label className="block text-sm font-medium text-gray-700">
                          Upload Review Files
                        </label>
                        <input
                          type="file"
                          className="block w-full text-sm text-gray-500 file:mr-4 file:py-2 file:px-4 file:rounded-full file:border-0 file:text-sm file:font-semibold file:bg-black file:text-white hover:file:bg-stone-700"
                          onChange={(e) => setFeedback(e.target.files[0])}
                        />
                        <select
                          className="mt-1 block w-full border-gray-300 rounded-md shadow-sm py-3 px-4 text-base"
                          onChange={(e) => setFileType(e.target.value)}
                        >
                          <option value hidden>
                            Select File Type
                          </option>
                          <option
                            value="first_draft_feedback"
                            disabled={
                              !files?.some(
                                (file) => file.type === "First Draft"
                              )
                            }
                          >
                            First Draft Feedback
                            {!files?.some(
                              (file) => file.type === "First Draft"
                            ) && " (First Draft was not submitted)"}
                          </option>
                          <option
                            value="examiner"
                            disabled={
                              !files?.some((file) => file.type === "Thesis")
                            }
                          >
                            Examiner's Feedback
                            {!files?.some((file) => file.type === "Thesis") &&
                              " (Files are not submitted yet)"}
                          </option>
                          <option
                            value="combined_form"
                            disabled={
                              files?.filter(
                                (file) => file.type === "Examiner's Feedback"
                              ).length < 2
                            }
                          >
                            Final Feedback
                            {files?.filter(
                              (file) => file.type === "Examiner's Feedback"
                            ).length < 2 && " (Need 2 Examiner's Feedbacks)"}
                          </option>
                        </select>
                        {fileType === "combined_form" && (
                          <p className="text-sm text-gray-500 mt-2">
                            Please note, as the final feedback is submitted, the
                            submission is going to be closed and sent to the
                            secretary for the evaluation.
                          </p>
                        )}
                      </div>
                      <div className="flex justify-end space-x-3 mt-4">
                        {/* <button className="px-4 py-2 text-sm font-medium text-gray-700 bg-red-100 border border-red-300 rounded-md shadow-sm hover:bg-red-200">
                                  Close Submission
                                  </button> */}
                        <button
                          onClick={(e) => {
                            e.preventDefault();
                            uploadFeedback().then(() => {
                              window.location.reload();
                            });
                          }}
                          disabled={feedback === null || fileType === null}
                          className={
                            feedback === null || fileType === null
                              ? "cursor-not-allowed rounded-md bg-gray-300 text-black px-4 py-2 text-sm font-medium"
                              : "px-4 py-2 text-sm font-medium text-white bg-black rounded-md shadow-sm hover:bg-black/85"
                          }
                        >
                          {fileType === "final_feedback"
                            ? "Submit Review"
                            : "Upload file"}
                        </button>
                      </div>
                    </div>
                  </div>
                ) : (
                  <div className="space-y-4 border-b pb-6">
                    <div className="flex justify-between items-center">
                      <h4 className="text-lg font-medium text-gray-900">
                        Teacher Review
                      </h4>
                    </div>
                    <div className="border rounded-lg p-4 space-y-4">
                      <p className="text-sm text-gray-500">
                        This submission has already been reviewed.
                      </p>
                    </div>
                  </div>
                )}
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* Second Teacher Selection */}
      {showTeacherModal && (
        <div className="fixed inset-0 z-50 flex items-center justify-center bg-black bg-opacity-40">
          <div className="bg-white rounded-lg shadow-lg w-full max-w-md p-6">
            <div className="flex justify-between items-center mb-4">
              <h3 className="text-lg font-semibold text-gray-800">
                Select Teacher
              </h3>
              <button
                onClick={() => setShowTeacherModal(false)}
                className="text-gray-500 hover:text-gray-700"
              >
                <i className="fas fa-times"></i>
              </button>
            </div>
            <input
              type="text"
              placeholder="Search teacher..."
              className="mb-4 w-full px-3 py-2 border border-gray-300 rounded-md shadow-sm focus:ring focus:ring-black"
              value={searchTerm}
              onChange={(e) => setSearchTerm(e.target.value)}
            />
            <ul className="max-h-40 overflow-y-auto divide-y divide-gray-200 mb-4">
              {filteredTeachers.map((teacher, index) => (
                <li
                  key={index}
                  onClick={() => setSelectedTeacher({ name: teacher })}
                  className={`py-2 px-3 text-gray-700 hover:bg-gray-100 cursor-pointer ${
                    selectedTeacher?.name === teacher ? "bg-gray-200" : ""
                  }`}
                >
                  {teacher}
                </li>
              ))}
            </ul>
            <div className="flex justify-between items-center mt-4">
              <span className="text-sm text-gray-600">
                {selectedTeacher
                  ? `Selected: ${selectedTeacher.name}`
                  : "No teacher selected"}
              </span>
              <div className="flex space-x-3">
                <button
                  onClick={() => setShowTeacherModal(false)}
                  className="px-4 py-2 text-sm font-medium text-gray-700 bg-gray-100 border border-gray-300 rounded-md hover:bg-gray-200"
                >
                  Cancel
                </button>
                <button className="px-4 py-2 text-sm font-medium text-white bg-black rounded-md hover:bg-black/80">
                  Apply
                </button>
              </div>
            </div>
          </div>
        </div>
      )}
    </>
  );
};

export default SubmissionReviewWindow;
